
import { Component, Prop, Vue } from 'vue-property-decorator';
import { OriginVhostInterface } from '@/services/Vhost/Origin/Interfaces';

@Component
export default class DeleteVhostDialog extends Vue {
  @Prop() private vhost!: OriginVhostInterface;
  @Prop() private readonly domain!: string;
  @Prop() private readonly onDelete!: CallableFunction;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove origin vhost ${this.domain}?`;
  }

  private destroyComponent(): void {
    this.$emit('close');
  }

  private async deleteVhost(): Promise<void> {
    this.$emit('delete', this.vhost);
    this.destroyComponent();
  }
}
